<ng-container [ngTemplateOutlet]="template" *ngIf="hasConsent; else consentOverlay">
  <ng-content *ngIf="hasConsent"></ng-content>
</ng-container>

<ng-template #consentOverlay>
  <div class="overlay-container">
    <img *ngIf="backgroundImageUrl" [src]="backgroundImageUrl" alt="Background image of a video or a map" />
    <div class="image-tint"></div>
    <div class="content-wrapper">
      <h5>{{ 'CONSENT_OVERLAY.' + translationKey[providerConfig] + '.HEADLINE' | translate }}</h5>
      <p class="description">
        {{ 'CONSENT_OVERLAY.' + translationKey[providerConfig] + '.DESCRIPTION' | translate }}
      </p>
      <div class="button-wrapper">
        <button (click)="showInfo()" class="btn btn-tertiary">
          {{ 'SHOW_INFORMATION' | translate }}
        </button>
        <button (click)="consent()" class="btn">
          {{ 'ACCEPT' | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
